package team.platforma.aicombo.activity.auth.component.fragment.registration

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.cross_m
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.produceState
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.intl.Locale
import androidx.compose.ui.text.intl.LocaleList
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import org.koin.compose.koinInject
import team.platforma.aicombo.theme.colors.AppColors
import team.platforma.aicombo.theme.colors.getOutlinedTextColors
import team.platforma.auth_presentable.viewModel.ConfirmEmailViewModel
import team.platforma.auth_presentable.viewModel.RegistrationViewModel
import team.platforma.extra_nav.component.fragment_component.Fragment
import team.platforma.extra_nav.utils.rememberKeyboardHeight
import team.platforma.multiplatform_material_extension.button.AppFilledButton
import team.platforma.multiplatform_material_extension.text_input.TextInput
import team.platforma.multiplatform_material_extension.ui.buttons.ExtraTextButton
import team.platforma.multiplatform_material_extension.ui.buttons.utils.ButtonText
import team.platforma.multiplatform_material_extension.ui.check_box.ExtraCheckBox

object EnterEmailFragment : Fragment(
    route = "registration_enter_email_fragment",
    fragmentBox = { componentNavigator, fragmentNavigator, paddingValues ->
        val regViewModel = koinInject<RegistrationViewModel>()
        val confirmCodeViewModel = koinInject<ConfirmEmailViewModel>()
        val keyboardHeight by rememberKeyboardHeight()

        var email by remember { mutableStateOf("") }
        val validInput by produceState(initialValue = false, email) {
            value =
                checkValid(
                    email
                )
        }

        var terms by rememberSaveable { mutableStateOf(false) }

        Box(modifier = Modifier.fillMaxSize()) {
            Scaffold(modifier = Modifier.fillMaxHeight().widthIn(max = 533.dp)
                .align(Alignment.Center),
                topBar = {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .background(color = AppColors.bg.base().default)
                            .heightIn(min = 64.dp).clickable {
                                fragmentNavigator.navigateBack()
                            },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        Spacer(modifier = Modifier.width(16.dp))
                        Text("Регистрация")
                        Spacer(modifier = Modifier.width(16.dp))
                    }
                }) { pV ->
                Box(modifier = Modifier.fillMaxSize().padding(pV)) {
                    Column(modifier = Modifier.fillMaxSize().padding(horizontal = 16.dp)) {
                        Text("Для получения кода подтверждения, пожалуйста, укажите адрес электронной почты.")

                        TextInput(
                            value = email,
                            onValueChange = {
                                email = it
                            },
                            modifier = Modifier.fillMaxWidth(),
                            label = {
                                Text(
                                    text = "Почта для регистрации"
                                )
                            },
                            placeholder = {
                                Text(
                                    text = "Адрес электронной почты"
                                )
                            },
                            trailingIcon = {
                                if (email.isNotEmpty()) {
                                    IconButton(
                                        onClick = {
                                            email = ""
                                        }
                                    ) {
                                        Icon(
                                            painter = painterResource(Res.drawable.cross_m),
                                            contentDescription = null
                                        )
                                    }
                                }
                            },
                            keyboardOptions = KeyboardOptions.Default.copy(
                                keyboardType = KeyboardType.Email,
                                hintLocales = LocaleList(Locale("en")),
                                imeAction = ImeAction.Next
                            ),
                            colors = getOutlinedTextColors()
                        )
                        Spacer(modifier = Modifier.height(16.dp))
                        AppFilledButton(
                            onClick = {
                                regViewModel.setEmail(email)
                                println("Email:${regViewModel.email.value}")
                                confirmCodeViewModel.clearViewModel()
                                fragmentNavigator.navigate(EnterVerificationCodeFragment)
                            },
                            enabled = validInput && terms,
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Text(
                                text = "Получить проверочный код"
                            )
                        }
                        Spacer(modifier = Modifier.height(16.dp))
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            ExtraCheckBox(
                                checked = terms,
                                onCheckedChange = { change ->
                                    terms = change
                                }
                            )

                            val termsString = buildAnnotatedString {
                                withStyle(style = SpanStyle(color = MaterialTheme.colorScheme.onBackground)) {
                                    append("Принимаю условия ")
                                }
                                withStyle(
                                    style = SpanStyle(
                                        color = MaterialTheme.colorScheme.primary,
                                        fontWeight = FontWeight.SemiBold
                                    )
                                ) {
                                    append("Пользовательского соглашения")
                                }
                            }

                            ExtraTextButton(
                                onClick = {
                                    //Show agreement
                                },
                                buttonText = ButtonText(
                                    textStyle = MaterialTheme.typography.bodyLarge
                                ).setAnnotatedString(termsString),
                                modifier = Modifier.weight(1f)
                            )

                        }
                        Spacer(modifier = Modifier.weight(1f))
                        AppFilledButton(
                            onClick = {
                                fragmentNavigator.navigateBack()
                            },
                            enabled = true,
                            modifier = Modifier.fillMaxWidth(),
                            colors = ButtonDefaults.buttonColors().copy(
                                contentColor = AppColors.text().primary,
                                containerColor = Color.Transparent
                            )
                        ) {
                            Text(
                                text = "Есть аккаунт - войти"
                            )
                        }
                        AppFilledButton(
                            onClick = {
                                //To restore password
                            },
                            enabled = true,
                            modifier = Modifier.fillMaxWidth(),
                            colors = ButtonDefaults.buttonColors().copy(
                                contentColor = AppColors.text().primary,
                                containerColor = Color.Transparent
                            )
                        ) {
                            Text(
                                text = "Если возникли вопросы - Напишите команде проекта"
                            )
                        }
                        Spacer(
                            modifier = Modifier.height(keyboardHeight)
                        )
                    }
                }
            }
        }
    }
)

private fun checkValid(email: String): Boolean {

    val enEmail = Regex("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}\$")
    val ruEmail = Regex("[а-яА-Я0-9._%+-]+@[а-яА-Я0-9.-]+\\.[а-яА-Я]{2,}\$")
    return enEmail.matches(email) || ruEmail.matches(email)
}